module.exports = __webpack_public_path__ + "static/20230619_081-0a47f1d5529383d1af712c2be1274a29.jpg";